<div class="close-icon" mat-button (click)="dialogRef.close()"></div>
<div class="upload-compliance-area-component">
    <h2 mat-dialog-title style="font-family: Roboto, 'Helvetica Neue', sans-serif;">Upload Compliance Area</h2>

    <alert></alert>

    <div>
        <mat-form-field class="example-full-width">
          <mat-label>Compliance Area Name</mat-label>
            <input matInput

                    name="complianceAreaName"
                    [(ngModel)]="complianceAreaName"
                    [disabled]="data"
                    required>
        </mat-form-field>
    </div>

    <div>
        <button mat-raised-button
            (click)="inputFile.click()"
            tyle="display: none; border-radius: 6px;"
            disabled="{{complianceAreaName == null
                || complianceAreaName == ''
                || loading}}">
                <i class="pi pi-paperclip"></i>
                Upload Compliance Area
        </button>

        <input #inputFile
                type="file"
                (change)="uploadComplianceArea($event)"
                [style.display]="'none'">

        <img *ngIf="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
        <button mat-raised-button
                (click)="onClose()"
                disabled="{{loading}}">
                Cancel
        </button>
    </div>
</div>
